import Link from "next/link";
import Image from "next/image";
import { FC } from "react";
import routes from "@/constants/routes";

const Hero: FC = () => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center w-full py-10 md:py-16 text-white bg-landing-blue relative px-5 lg:px-20 xl:pt-24 h-fit justify-between">
      <div className="w-full md:w-auto lg:w-1/2 h-auto">
        <h1>
          <span className="text-4xl font-bold md:text-6xl md:whitespace-nowrap xl:text-7xl text-landing-orange ">
            Helping you
          </span>
          <span className="block mt-2 text-4xl font-bold md:text-6xl md:whitespace-nowrap text-landing-white xl:text-7xl">
            rent to buy
          </span>
          <span className="block mt-2 text-4xl font-bold md:text-6xl md:whitespace-nowrap text-landing-orange xl:text-7xl">
            your first home
          </span>
        </h1>
        <h2 className="text-landing-wite font-serif text-xl max-w-xs xs:max-w-md md:max-w-none xl:text-2xl md:mt-4 xl:mt-7 md:leading-8 mt-7 md:w-[19.8rem] xl:w-[30.375rem]">
          Let your rent build your path to homeownership!
        </h2>
        <Link href={routes.register}>
          <a className="inline-block px-4 py-3 w-full md:w-auto text-center mx-auto text-base font-bold text-landing-blue transition duration-300 ease-in-out transform rounded shadow mt-7 md:mt-16 xl:mt-24 xl:mb-12 bg-landing-orange hover:scale-105 text-xl">
            Apply today!
          </a>
        </Link>
      </div>

      <div className="relative h-48 md:h-64 lg:h-96 w-full mt-16 md:mt-0">
        <Image
          src="/first-time-buyers/hero-first-time-buyers.svg"
          alt="Key Workers Image"
          objectFit="contain"
          priority
          layout="fill"
        />
      </div>
    </div>
  );
};

export default Hero;
